import React, { useState } from 'react';
import { Button } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { selectedWidgetsAtom } from '../state/atoms';
import { useAtom } from 'jotai';
import { GLOBAL_MAX_WIDGETS_ALLOWED, SINGLE_SELECT } from '../config/constants';
import { StyledInputBox, InputNumber } from './styled';

const ActionButton = ({ type, select = SINGLE_SELECT, localLimit = 1, addedWidgetsCount = 0 }) => {
  const [selected, setSelected] = useAtom(selectedWidgetsAtom);
  const max = GLOBAL_MAX_WIDGETS_ALLOWED;

  const handleAdd = () => {
    setSelected((prev) => {
      const prevWidgets = prev.widgets;
      const newCount = prevWidgets[type] ? prevWidgets[type] + 1 : 1;
      const newSelected = { ...prev };
      newSelected.totalCount += 1;
      newSelected.widgets[type] = newCount;
      return newSelected;
    });
  };

  const handleSubtract = () => {
    setSelected((prev) => {
      const prevWidgets = prev.widgets;
      const newCount = prevWidgets[type] - 1;
      const newSelected = { ...prev };
      if (newCount === 0) delete newSelected.widgets[type];
      else newSelected.widgets[type] = newCount;
      newSelected.totalCount -= 1;
      return newSelected;
    });
  };

  const currentItemCount = selected.widgets[type] ? selected.widgets[type] : 0;

  const totalCount = addedWidgetsCount + selected.totalCount;

  const isDisableAdd = totalCount >= max || currentItemCount >= localLimit;

  const MultiSelectButton = () => (
    <StyledInputBox>
      <Button
        icon={<MinusOutlined />}
        onClick={() => {
          handleSubtract();
        }}
      />

      <InputNumber onMouseDown={(e) => e.preventDefault()}>{currentItemCount}</InputNumber>

      <Button
        disabled={isDisableAdd}
        icon={<PlusOutlined />}
        onClick={() => {
          handleAdd();
        }}
      />
    </StyledInputBox>
  );

  const SingleSelectButton = () => {
    const [isHover, setHover] = useState(false);
    const [showRemove, setShowRemove] = useState(false);
    return (
      <Button
        onMouseEnter={() => {
          if (showRemove) setHover(true);
        }}
        onMouseLeave={() => {
          if (!showRemove) setShowRemove(true);
          setHover(false);
        }}
        danger={isHover}
        onClick={() => {
          handleSubtract();
          setShowRemove(false);
        }}
      >
        {isHover ? 'Remove' : 'Added'}
      </Button>
    );
  };

  const InitButton = () => (
    <Button
      disabled={isDisableAdd}
      onClick={() => {
        handleAdd();
      }}
    >
      Add
    </Button>
  );

  return currentItemCount === 0 ? (
    <InitButton />
  ) : select === SINGLE_SELECT ? (
    <SingleSelectButton />
  ) : (
    <MultiSelectButton />
  );
};

export default ActionButton;
